import { User } from "lucide-react";
import { useTranslate, useUserMenu } from "ra-core";
import { Link } from "react-router";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

export const ProfileMenu = () => {
  const translate = useTranslate();
  const userMenuContext = useUserMenu();
  if (!userMenuContext) return null;
  return (
    <DropdownMenuItem asChild onClick={userMenuContext.onClose}>
      <Link to="/profile" className="flex items-center gap-2">
        <User />
        {translate("crm.profile.title")}
      </Link>
    </DropdownMenuItem>
  );
};
